export const EMPTY = ` `;

export const UNTRANSLATED = `----------`;

export const WIP = (value) => value;
